import {useMutation} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {stepUpApi} from '../api';

import type {VerifyStepUpCodePayload} from '@sollapay/types';

export function useVerifyStepUpCodeMutation() {
  const client = useApiClient();

  return useMutation({
    mutationFn: async (payload: VerifyStepUpCodePayload) => {
      const response = await stepUpApi.verifyCode(client, payload);
      return response.data;
    }
  });
}
